/* ========================================================================== 
   Nootrópicos México v71.60R7 — Floating Runtime

   Fuente única para coordinar:
   - Shopify Inbox moderno (<shopify-chat>) y launchers antiguos,
   - ProveSource,
   - FAB de Nootro-IA,
   - barra sticky de compra.

   El web component actual de Inbox mide 0px de alto y coloca su launcher con
   position:absolute. Por eso no sirve detectar únicamente su rectángulo: el
   host debe fijarse al viewport y su offset público se controla con la custom
   property --shopify-agent-activator-offset.

   v71.60R7: el dock de ProveSource se aplica a sus dos nodos reales
   (#provesrc-widget-area y #provesrc-notification-container). El área externa
   queda neutra y la notificación visible se fija a la derecha. Así evitamos
   que un shell de pantalla completa conserve el left:0 del proveedor.
   ========================================================================== */
(function () {
  "use strict";

  var MOBILE_MAX = 989;
  var PROOF_SELECTOR = [
    "#prove-source-container",
    "#provesource-container",
    "#ps-container",
    '[id*="provesource"]',
    '[class*="provesource"]',
    '[id*="prove-source"]',
    '[class*="prove-source"]',
    '[id*="proofsource"]',
    '[class*="proofsource"]',
    '[id*="proof-source"]',
    '[class*="proof-source"]',
    '[id*="provesrc"]',
    '[class*="provesrc"]',
    ".ps-widget",
    ".ps-notification",
    ".provesrc-notification",
    'iframe[src*="provesource"]',
    'iframe[src*="proofsource"]',
    'iframe[title*="ProveSource"]',
  ].join(",");

  var CHAT_SELECTOR = [
    "shopify-chat",
    "#shopify-chat",
    "#ShopifyChat",
    ".shopify-chat",
    ".shopify-chat--launcher",
    ".shopify-inbox-launcher",
    ".shopify-chat-launcher",
    "#dummy-chat-button-iframe",
    'iframe[title*="Shopify Inbox"]',
    'iframe[title*="chat"]',
    'iframe[src*="shopify.com/chat"]',
    'iframe[src*="inbox.shopify"]',
    'iframe[src*="shopifyinbox"]',
  ].join(",");

  var observedTargets = new WeakSet();
  var observedProofTargets = new WeakSet();
  var frame = 0;

  function isMobile() {
    return window.innerWidth <= MOBILE_MAX;
  }

  function safeBottom(value) {
    var pixels = Math.round(value) + "px";
    return isMobile()
      ? "calc(" + pixels + " + env(safe-area-inset-bottom, 0px))"
      : pixels;
  }

  function safeLeft(value) {
    var pixels = Math.round(value) + "px";
    return isMobile()
      ? "max(" + pixels + ", env(safe-area-inset-left, 0px))"
      : pixels;
  }

  function safeRight(value) {
    var pixels = Math.round(value) + "px";
    return isMobile()
      ? "max(" + pixels + ", env(safe-area-inset-right, 0px))"
      : pixels;
  }

  function isShopifyChatHost(el) {
    return Boolean(el && el.tagName && el.tagName.toLowerCase() === "shopify-chat");
  }

  function viewportHeight() {
    return (
      (window.visualViewport && window.visualViewport.height) ||
      window.innerHeight ||
      document.documentElement.clientHeight ||
      0
    );
  }

  function setImportant(el, prop, value) {
    if (!el || !el.style) return;
    if (
      el.style.getPropertyValue(prop) !== value ||
      el.style.getPropertyPriority(prop) !== "important"
    ) {
      el.style.setProperty(prop, value, "important");
    }
  }

  function visibleRect(el) {
    if (!el || !el.getBoundingClientRect) return null;
    if (isShopifyChatHost(el) && el.shadowRoot) {
      var activator = el.shadowRoot.querySelector('[part="activator"]');
      if (activator) return activator.getBoundingClientRect();
    }
    return el.getBoundingClientRect();
  }

  function isVisible(el) {
    if (!el || !el.getBoundingClientRect) return false;
    var style = window.getComputedStyle(el);
    if (
      style.display === "none" ||
      style.visibility === "hidden" ||
      parseFloat(style.opacity || "1") === 0
    ) {
      return false;
    }
    if (isShopifyChatHost(el)) return true;
    var rect = visibleRect(el);
    return Boolean(rect && rect.width > 0 && rect.height > 0);
  }

  function queryAll(selector) {
    try {
      return Array.prototype.slice.call(document.querySelectorAll(selector));
    } catch (error) {
      return [];
    }
  }

  function topLevelVisible(nodes) {
    var visible = nodes.filter(isVisible);
    return visible.filter(function (el) {
      return !visible.some(function (candidate) {
        return (
          candidate !== el &&
          candidate.contains &&
          candidate.contains(el)
        );
      });
    });
  }

  function firstVisible(selector) {
    var nodes = queryAll(selector);
    for (var i = 0; i < nodes.length; i += 1) {
      if (isVisible(nodes[i])) return nodes[i];
    }
    return null;
  }

  function getRailLeft() {
    var basis = firstVisible(".sidebar-module") || firstVisible(".site-header__logo");
    if (!basis) return 20;
    return Math.max(20, Math.round(basis.getBoundingClientRect().left));
  }

  function stickyState() {
    var sticky = document.getElementById("nmStickyATC");
    var active = false;
    var height = 0;

    if (isMobile() && sticky) {
      var style = window.getComputedStyle(sticky);
      active =
        sticky.classList.contains("is-visible") &&
        style.display !== "none" &&
        style.visibility !== "hidden";
      if (active) height = Math.ceil(sticky.getBoundingClientRect().height);
    }

    document.documentElement.classList.toggle("nm-sticky-atc-active", active);
    document.documentElement.style.setProperty(
      "--nm-sticky-atc-height",
      height + "px",
    );
    return { active: active, height: height };
  }

  function widgetStack(sticky) {
    if (!isMobile()) {
      return { fab: 22, chat: 20, proof: 104 };
    }
    var safeBottom = sticky.active ? sticky.height + 14 : 14;
    var chatBottom = Math.max(82, safeBottom + 68);
    return {
      fab: safeBottom,
      chat: chatBottom,
      /* Dock de dos columnas: ProveSource acompaña chat + FAB, no los apila. */
      proof: sticky.active ? sticky.height + 6 : 8,
    };
  }

  function positionFab(stack) {
    var fab = document.getElementById("nmChatFab");
    if (!fab) return;
    setImportant(fab, "position", "fixed");
    setImportant(fab, "top", "auto");
    setImportant(fab, "right", isMobile() ? "auto" : "22px");
    setImportant(fab, "left", isMobile() ? safeLeft(14) : "auto");
    setImportant(fab, "bottom", safeBottom(stack.fab));
    setImportant(fab, "z-index", "2147482700");
    fab.classList.remove("nm-fab-force-left");
  }

  function positionProof(el, stack) {
    if (!isVisible(el)) return;

    setImportant(el, "position", "fixed");
    setImportant(el, "box-sizing", "border-box");
    setImportant(el, "top", "auto");
    setImportant(el, "bottom", safeBottom(stack.proof));
    setImportant(el, "z-index", "2147482400");
    setImportant(el, "transition", "bottom 240ms ease-out, opacity 200ms ease");

    if (isMobile()) {
      setImportant(el, "left", "auto");
      setImportant(el, "right", safeRight(8));
      setImportant(el, "max-width", Math.min(340, window.innerWidth - 16) + "px");
    } else {
      setImportant(el, "left", "auto");
      setImportant(el, "right", "22px");
      setImportant(el, "max-width", "300px");
    }
  }

  function knownProofElements() {
    return {
      area: document.getElementById("provesrc-widget-area"),
      container: document.getElementById("provesrc-notification-container"),
    };
  }

  function isInsideKnownProof(el, known) {
    if (!el || !known) return false;
    if (el === known.area || el === known.container) return true;
    if (known.area && known.area.contains && known.area.contains(el)) return true;
    return Boolean(
      known.container &&
      known.container.contains &&
      known.container.contains(el),
    );
  }

  function observeKnownProof(el) {
    if (!window.MutationObserver || !el || observedProofTargets.has(el)) return;
    observedProofTargets.add(el);
    var observer = new MutationObserver(schedule);
    observer.observe(el, {
      attributes: true,
      attributeFilter: ["class", "style", "view"],
      childList: true,
      subtree: true,
    });
  }

  function positionKnownProof(known, stack) {
    var area = known.area;
    var container = known.container;

    if (area) {
      /* El shell puede medir toda la pantalla: se conserva, pero no posiciona
         ni bloquea la página. El contenedor visible se ancla por separado. */
      setImportant(area, "position", "fixed");
      setImportant(area, "top", "0px");
      setImportant(area, "right", "0px");
      setImportant(area, "bottom", "0px");
      setImportant(area, "left", "0px");
      setImportant(area, "width", "auto");
      setImportant(area, "height", "auto");
      setImportant(area, "margin", "0px");
      setImportant(area, "transform", "none");
      setImportant(area, "overflow", "visible");
      setImportant(area, "pointer-events", "none");
      setImportant(area, "background", "transparent");
      setImportant(area, "border", "0px");
      setImportant(area, "box-shadow", "none");
      setImportant(area, "z-index", "2147482400");
      observeKnownProof(area);
    }

    if (!container) return Boolean(area);

    setImportant(container, "position", "fixed");
    setImportant(container, "box-sizing", "border-box");
    setImportant(container, "top", "auto");
    setImportant(container, "left", "auto");
    setImportant(container, "right", isMobile() ? safeRight(8) : "12px");
    setImportant(container, "bottom", safeBottom(stack.proof));
    setImportant(container, "width", "fit-content");
    setImportant(
      container,
      "max-width",
      isMobile()
        ? Math.min(250, window.innerWidth - 108) + "px"
        : "clamp(212px, 18vw, 280px)",
    );
    setImportant(container, "min-width", "0px");
    setImportant(container, "height", "auto");
    setImportant(container, "margin", "0px");
    setImportant(container, "transform", "none");
    setImportant(container, "overflow", "visible");
    setImportant(container, "pointer-events", "none");
    setImportant(container, "background", "transparent");
    setImportant(container, "border", "0px");
    setImportant(container, "box-shadow", "none");
    setImportant(container, "z-index", "2147482400");
    setImportant(
      container,
      "transition",
      "bottom 240ms ease-out, opacity 200ms ease",
    );
    observeKnownProof(container);
    return true;
  }

  function positionShopifyHost(el, stack) {
    /* body > * recibe position:relative en custom.css; esta regla lo neutraliza. */
    setImportant(el, "position", "fixed");
    setImportant(el, "left", "0px");
    setImportant(el, "right", "0px");
    setImportant(el, "top", "auto");
    setImportant(el, "bottom", "0px");
    setImportant(el, "width", "100%");
    setImportant(el, "height", "0px");
    setImportant(el, "max-width", "none");
    setImportant(el, "overflow", "visible");
    setImportant(el, "z-index", "2147482600");
    setImportant(
      el,
      "--shopify-agent-activator-offset",
      safeBottom(stack.chat),
    );
    el.classList.add("nm-v709-shopify-chat");
  }

  function positionLegacyChat(el, stack) {
    if (!isVisible(el)) return;
    var viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;
    var viewportH = viewportHeight();
    if (!viewportWidth || !viewportH) return;

    var rect = visibleRect(el);
    var looksOpen = rect && (rect.width > 180 || rect.height > 120);
    setImportant(el, "position", "fixed");
    setImportant(el, "top", "auto");
    setImportant(el, "left", isMobile() ? safeLeft(14) : "22px");
    setImportant(el, "right", "auto");
    setImportant(el, "bottom", safeBottom(stack.chat));
    setImportant(el, "z-index", "2147482600");
    if (!looksOpen) return;

    var maxHeight = Math.max(280, Math.floor(viewportH - stack.chat - 8));
    var maxWidth = Math.max(280, Math.floor(viewportWidth - 22));
    setImportant(el, "max-height", maxHeight + "px");
    setImportant(el, "max-width", maxWidth + "px");
    setImportant(el, "box-sizing", "border-box");
  }

  function positionChat(el, stack) {
    if (isShopifyChatHost(el)) {
      positionShopifyHost(el, stack);
      return;
    }
    positionLegacyChat(el, stack);
  }

  function observeTarget(el) {
    if (!window.MutationObserver || !el || observedTargets.has(el)) return;
    observedTargets.add(el);
    var observer = new MutationObserver(schedule);
    observer.observe(el, {
      attributes: true,
      attributeFilter: ["class", "style", "view"],
      childList: true,
      subtree: false,
    });
  }

  function run() {
    frame = 0;
    var sticky = stickyState();
    var stack = widgetStack(sticky);
    var knownProof = knownProofElements();
    var proofs = topLevelVisible(queryAll(PROOF_SELECTOR)).filter(function (el) {
      return !isInsideKnownProof(el, knownProof);
    });
    var chats = topLevelVisible(queryAll(CHAT_SELECTOR));
    var stickyEl = document.getElementById("nmStickyATC");

    if (stickyEl) observeTarget(stickyEl);
    positionKnownProof(knownProof, stack);
    proofs.forEach(function (el) {
      observeTarget(el);
      positionProof(el, stack);
    });
    chats.forEach(function (el) {
      observeTarget(el);
      positionChat(el, stack);
    });
    positionFab(stack);

    document.documentElement.classList.toggle(
      "nm-shopify-chat-mounted",
      chats.some(isShopifyChatHost),
    );
  }

  function schedule() {
    if (!frame) frame = window.requestAnimationFrame(run);
  }

  if (window.MutationObserver) {
    new MutationObserver(schedule).observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }

  window.addEventListener("load", schedule, { passive: true });
  window.addEventListener("resize", schedule, { passive: true });
  window.addEventListener("nm:sticky-atc-change", schedule);
  document.addEventListener("nm:provesource-ready", schedule);
  if (window.visualViewport) {
    window.visualViewport.addEventListener("resize", schedule, { passive: true });
  }
  document.addEventListener(
    "click",
    function () {
      window.setTimeout(schedule, 80);
      window.setTimeout(schedule, 350);
    },
    true,
  );

  [0, 250, 700, 1500, 3000, 5000, 8000].forEach(function (delay) {
    window.setTimeout(schedule, delay);
  });
})();
